import { useRef } from "react";

export default function HygieneChecksTable({ data }) {
    const rows = [...(data ?? [])].sort((a, b) => (b.cnt ?? 0) - (a.cnt ?? 0));
    const rowCount = rows.length;
    const bodyRef = useRef(null);

    // Return a shade of muted blue-gray based on row index (top darker → bottom lighter)
    const getShade = (index) => {
        const ratio = 1 - index / Math.max(1, rowCount - 1); // 1 → 0
        const lightness = 97 - ratio * 22; // top row darker (65%), bottom row lighter (87%)
        return `hsl(206, 35%, ${lightness}%)`;
    };

    return (
        <div className="hc-box" style={{ height: "354px", display: "flex", flexDirection: "column" }}>
            <div className="hc-title">Hygiene Checks</div>
            <div className="hc-body" ref={bodyRef} style={{ flex: 1, overflow: "auto", minHeight: 0 }}>
                <div className="hc-body-inner">
                <table className="hc-table">
                    <tbody>
                    {rows.map((r, i) => (
                        <tr key={i}>
                            <td
                                className="hc-desc"
                                title={r.description}
                                style={{
                                    backgroundColor: getShade(i),
                                    color: "#333",
                                }}
                            >
                                {r.description}
                            </td>
                            <td
                                className="hc-cnt"
                                style={{
                                    backgroundColor: getShade(i),
                                    color: "#333",
                                }}
                            >
                                {r.cnt?.toLocaleString()}
                            </td>
                        </tr>
                    ))}
                    </tbody>
                </table>
                </div>
            </div>
        </div>
    );
}
